import type { WriteIdentity } from '@/core/api/http'
import {
  deleteDocument,
  downloadDocument,
  listDocuments,
  moveDocument,
  uploadDocument,
} from '@/core/api/storage'

export async function uploadFile(blob: Blob, filename: string, identity?: WriteIdentity): Promise<string> {
  const stored = await uploadDocument(blob, filename, identity)
  return stored.bucket_address
}

export async function downloadFile(path: string): Promise<Blob | null> {
  try {
    return await downloadDocument(path)
  } catch {

    return null
  }
}

export async function removeFile(path: string, identity?: WriteIdentity): Promise<void> {
  await deleteDocument(path, identity)
}

export async function moveFile(fromPath: string, toPath: string): Promise<string> {
  const moved = await moveDocument(fromPath, toPath)
  return moved.bucket_address
}

export async function listFiles(prefix: string): Promise<string[]> {
  const objects = await listDocuments(prefix)
  return objects.map((o) => o.key)
}

export function extFromFile(file: File): string {
  const dot = file.name.lastIndexOf('.')
  const nameExt = dot > 0 ? file.name.slice(dot + 1) : ''
  if (/^[a-zA-Z0-9]{1,5}$/.test(nameExt)) return nameExt.toLowerCase()
  if (file.type === 'image/png') return 'png'
  if (file.type === 'image/jpeg') return 'jpg'
  return 'pdf'
}

export function versionedFile(base: string, ext: string): string {
  return `${base}-${Date.now()}.${ext}`
}

export function docPath(coachingId: string, file: string): string {
  return `coaching/${coachingId}/${file}`
}
